import React from 'react'; 
import Homepage from './pages/homepage';
import ContactUs from './pages/contactus';
import privacyPolicy from './pages/privacypage';
import termsPage from './pages/termspage';
import Blog from './pages/blog';
import BlogDetail from './pages/blogdetail';
import Questionaire from './pages/questionare';
import HowItWorks from './pages/howitworks';
import MedicalServices from './pages/medicalservices';
import Telecommunication from "./pages/telecommunicationservices";
import OffersPage from "./pages/OffersPage";
import './App.css';
import { BrowserRouter as Switch, Route } from 'react-router-dom';
import 'antd/dist/antd.css';
import WhatWeOffer from './pages/offering';
function App() {
  return (
    <>
    <Switch>
      <Route path="/" exact component={Homepage} />
      <Route path ="/contact" exact component={ContactUs} />
      <Route path ="/contact/:Faqs" exact component={ContactUs} />
      <Route path="/blog" exact component={Blog} />
      <Route path="/blog/:id" exact component={BlogDetail} />
      <Route path="/question" exact component={Questionaire} />
      <Route path="/medical-services" exact component={MedicalServices} />
      <Route path="/telecommunication-services" exact component={Telecommunication} />
      <Route path="/howitworks" exact component={HowItWorks} />
      <Route path ="/privacy" exact component={privacyPolicy} />
      <Route path ="/terms" exact component={termsPage} />
      <Route path ="/offers" exact component={OffersPage} />
      <Route path ="/offering" exact component={WhatWeOffer} />
    </Switch>
    </>
  );
}

export default App;
